<template>
    <div class="main-content">
        <div class="uk-padding" v-if="this.$store.state.core.user">
            <ul class="uk-breadcrumb">
                <li><router-link to="/pages">Pagina's</router-link></li>
                <li><router-link :to="{ name: 'PageEdit', params: { id: $route.params.id }}">Bewerk pagina</router-link></li>
            </ul>
            <h1>Bewerk Pagina</h1>
            <div>
                <div class="uk-card uk-card-default uk-card-body uk-margin-small" v-for="(s, id) in sections">
                    <div class="">
                        <div class="uk-align-left">
                            <p class="uk-card-title">{{s.name}}</p>
                        </div>
                        <div v-if="$store.state.core.user.role >= 3" class="uk-align-right">
                            <span class="uk-link uk-margin" @click="deleteSection(id)" uk-icon="icon: trash; ratio: 1"></span>
                        </div>
                    </div>
                    <br>
                    <table class="uk-table">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Veldnaam</th>
                                <th>Waarde</th>
                                <th v-if="$store.state.core.user.role >= 4"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(field, key) in s.fields">
                                <td width="30"><span class="uk-link uk-margin" uk-toggle href="#field-modal" @click="setEdit(id, key, field)" uk-icon="icon: pencil; ratio: 1.5"></span></td>
                                <td>{{key}}</td>
                                <td v-if="field.type == 'link'"><a target="_blank" :href="field.value.url">{{field.value.text}}</a></td>
                                <td v-else-if="!isImage(field)">{{field.value}}</td>
                                <td v-else><vue-image :img="field.value" :size="4"/></td>
                                <td v-if="$store.state.core.user.role >= 4" width="30"><span class="uk-link uk-margin" @click="deleteField(id, key)" uk-icon="icon: trash; ratio: 1.2"></span></td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-if="$store.state.core.user.role >= 3" href="#field-modal" @click="setSelectedSection(id)" uk-toggle class="uk-placeholder uk-text-center uk-link"><span class="uk-padding-small" uk-icon="icon: plus; ratio: 1"></span>VOEG VELD TOE</div>
                    <hr class="uk-text-primary uk-divider-icon"/>
                </div>
                <div v-if="$store.state.core.user.role >= 3" href="#section-modal" uk-toggle class="uk-placeholder uk-text-center uk-link"><span class="uk-padding-small" uk-icon="icon: plus; ratio: 1"></span>VOEG SECTIE TOE</div>
            </div>
        </div>
        <div id="section-modal" uk-modal>
            <div class="uk-modal-dialog">
                <button class="uk-modal-close-default" type="button" uk-close></button>
                <div class="uk-modal-header">
                    <h2 class="uk-modal-title">Sectie toevoegen</h2>
                </div>
                <div class="uk-modal-body">
                    <form>
                        <fieldset class="uk-fieldset">
                             <div class="uk-margin">
                                <input class="uk-input" v-model="newSection" type="text" placeholder="Naam">
                            </div>
                        </fieldset>
                    </form>
                </div>
                <div class="uk-modal-footer">
                    <div class="uk-align-right">
                        <button class="uk-button uk-button-primary uk-align-right uk-modal-close" type="submit" @click="addSection">Toevoegen</button>
                        <button class="uk-button uk-button-danger uk-align-right uk-modal-close">Annuleren</button>
                    </div>
                </div>
            </div>
        </div>
        <div id="field-modal" uk-modal>
            <div class="uk-modal-dialog">
                <button class="uk-modal-close-default" type="button" uk-close></button>
                <div class="uk-modal-header">
                    <h2 v-if="editing" class="uk-modal-title">Veld bewerken</h2>
                    <h2 v-else class="uk-modal-title">Veld toevoegen</h2>
                </div>
                <div class="uk-modal-body">
                    <form>
                        <fieldset class="uk-fieldset">
                             <div class="uk-margin">
                                <input v-if="!editing" class="uk-input" v-model="newField.name" type="text" placeholder="Naam">
                                <h3 v-else>{{newField.name}}</h3>
                            </div>
                            <ul v-if="!editing" uk-tab>
                                <li class="uk-active"><a @click="selectCurrentType('text')" href="#">Tekst</a></li>
                                <li><a @click="selectCurrentType('img')" href="#">Afbeelding</a></li>
                                <li><a @click="selectCurrentType('link')" href="#">Link</a></li>
                                <li><a @click="selectCurrentType('wysiwyg')" href="#">WYSIWYG</a></li>
                            </ul>
                            <div v-if="!editing">
                                <div class="uk-margin" v-if="currentType == 'text'">
                                    <textarea class="uk-input" v-model="newField.value" type="text" placeholder="Naam"></textarea>
                                </div>
                                <div class="uk-margin" v-if="currentType == 'img'">
                                    <image-picker @choose="choose"></image-picker>
                                </div>
                                <div class="uk-margin" v-if="currentType == 'link'">
                                    <input class="uk-input uk-margin" type="text" v-model="newField.value.text" placeholder="Link tekst"/>
                                    <input class="uk-input" type="text" v-model="newField.value.url" placeholder="URL"/>
                                </div>
                                <div class="uk-margin" v-if="currentType == 'wysiwyg'">
                                    <Vueditor ref="editor"></Vueditor>
                                </div>
                            </div>
                            <div v-if="editing">
                                <div class="uk-margin" v-if="newField.type == 'link'">
                                    <input class="uk-input uk-margin" type="text" v-model="newField.value.text" placeholder="Link tekst"/>
                                    <input class="uk-input" type="text" v-model="newField.value.url" placeholder="URL"/>
                                </div>
                                
                                <div class="uk-margin" v-else-if="typeof newField.value == 'object' || typeof newField.value == 'array'">
                                    <vue-image :img="newField.value"/>
                                    <image-picker class="uk-margin" :multiple="typeof newField.value == 'array'" @choose="choose"></image-picker>
                                </div>
                                <div class="uk-margin" v-else-if="newField.type == 'wysiwyg'">
                                    <Vueditor ref="editor"></Vueditor>
                                </div>
                                <div class="uk-margin" v-else>
                                    <textarea class="uk-input" v-model="newField.value" type="text" placeholder="Naam"></textarea>
                                </div>
                            </div>
                            
                        </fieldset>
                    </form>
                </div>
                <div class="uk-modal-footer">
                    <div class="uk-align-right">
                        <button v-if="editing" class="uk-button uk-button-primary uk-align-right uk-modal-close" type="submit" @click.prevent="editField">Bewerken</button>
                        <button v-else class="uk-button uk-button-primary uk-align-right uk-modal-close" type="submit" @click.prevent="addField">Toevoegen</button>
                        <button class="uk-button uk-button-danger uk-align-right uk-modal-close" @click="cancel" >Annuleren</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
var moment = require('moment');
import firebase from 'firebase'
import {db} from '@/CUSTOM/helpers/firebase'
import imagePicker from '@/CORE/modules/MEDIA/imagePicker'
import VueImage from '@/CORE/modules/MEDIA/VueImage'
import UIkit from 'uikit'

export default {
    name: 'PageEdit',
    components: {imagePicker, VueImage},
    data () {
        return {
            page: null,
            sections: [],
            selectedSection: null,
            newSection: null,
            editing: false,
            currentType: 'text',
            newField: {
                name: null,
                value: null
            }
        }
    },
    created () {
        db.collection('pages').doc(this.$route.params.id).onSnapshot((snap) => {
            this.page = snap.data()
        })
        db.collection('pages').doc(this.$route.params.id).collection('sections').orderBy("order").onSnapshot((snap) => {
            this.sections = {}
            snap.forEach((doc) => {
                this.sections[doc.id] = doc.data()                
            })
        })
    },
    methods: {
        isImage(field) {
            if(field.value.url || field.value[0].url) {
                return true
            } else {
                return false
            }
        },
        addSection () { 
            //TODO CHECK IF SECTION NAME EXSISTS!
            db.collection('pages').doc(this.$route.params.id).collection('sections').doc(this.newSection).set({'lastEdit': Math.floor(Date.now() / 1000), 'author': this.$store.state.core.user.uid, name: this.newSection, order: 1 + Object.keys(this.sections).length}).then(() => {
                this.$store.dispatch('PUSH_NOTIFICATION', {message: 'Section toegevoegd', status: 'success'})
                this.newSection = null
                this.updateEditTimestamp()
            })
            
        },
        selectCurrentType(type){
            this.currentType=type
            if(this.currentType == 'link') {
                this.newField.value = {url: '', text: ''}
            } else {
                this.newField.value = null
            }
        },
        addField () {
            var order = 1;
            if (this.sections[this.selectedSection]['fields']) {
                order = Object.keys(this.sections[this.selectedSection]['fields']).length + 1
            } else {
                this.sections[this.selectedSection]['fields'] = {}
            }
            this.newField.type = this.currentType
            if(this.currentType == 'wysiwyg') {
                this.newField.value = this.$refs.editor.getContent();
            }
            this.sections[this.selectedSection]['fields'][this.newField.name] = {value: this.newField.value, type: this.newField.type, order: order, 'author': this.$store.state.core.user.uid, 'lastEdit': Math.floor(Date.now() / 1000)}
            db.collection('pages').doc(this.$route.params.id).collection('sections').doc(this.selectedSection).update(this.sections[this.selectedSection]).then(res => {
                this.$store.dispatch('PUSH_NOTIFICATION', {message: 'Veld toegepast', status: 'success'})
                this.newField = {
                    name: null,
                    value: null
                }
                this.currentType = 'text'
                this.selectedSection = null
                this.editing = false
                this.updateEditTimestamp()
            })
            
        },
        editField () {
            if (this.newField.type == 'wysiwyg') {
                this.newField.value = this.$refs.editor.getContent();
            }
            this.sections[this.selectedSection]['fields'][this.newField.name].value = this.newField.value
            this.sections[this.selectedSection]['fields'][this.newField.name].lastEdit = Math.floor(Date.now() / 1000)
            this.sections[this.selectedSection]['fields'][this.newField.name].author = this.$store.state.core.user.uid
            db.collection('pages').doc(this.$route.params.id).collection('sections').doc(this.selectedSection).update(this.sections[this.selectedSection]).then(res => {
                this.$store.dispatch('PUSH_NOTIFICATION', {message: 'Veld aangepast', status: 'success'})
                this.updateEditTimestamp()
                this.cancel()
            })
        },
        setSelectedSection(id) {
            this.selectedSection = id
        },
        cancel () {
            this.editing = false
            this.newField = {
                name: null,
                value: null
            }
        },
        setEdit (id, key, field) {
            this.selectedSection = id
            this.editing = true
            this.newField = {
                name: key,
                value: field.value,
                type: field.type
            }
            if(field.type == 'wysiwyg') {
                setTimeout(() => {
                    this.$refs.editor.setContent(field.value);
                }, 200)
                
            }
        },
        deleteSection (id) {
            db.collection('pages').doc(this.$route.params.id).collection('sections').doc(id).delete().then(() => {
                this.$store.dispatch('PUSH_NOTIFICATION', {message: 'Section verwijderd', status: 'danger'})
                this.updateEditTimestamp()
            })  
        },
        deleteField (id, key) {
            delete this.sections[id]['fields'][key]
            db.collection('pages').doc(this.$route.params.id).collection('sections').doc(id).update(this.sections[id]).then(() => {
                this.$store.dispatch('PUSH_NOTIFICATION', {message: 'Veld verwijderd', status: 'danger'})
                this.updateEditTimestamp()
            })
        },
        updateEditTimestamp () {
            db.collection('pages').doc(this.$route.params.id).update({lastEdit: Math.floor(Date.now() / 1000)})
        },
        choose (images) {
            if(Object.keys(images).length > 1) {
                this.newField.value = []
                for(var i in images) {
                    var img = images[i]
                    this.newField.value.push({key: i, description: img.description, url: img.url, medium: img.medium, extralarge: img.extralarge || img.large, large: img.large, small: img.small, cover: false, placeholder: img.placeholder, alt: img.alt, title: img.title})
                }
            } else {
                for(var i in images) {
                    var img = images[i]
                    this.newField.value = {key: i, description: img.description, url: img.url, medium: img.medium, extralarge: img.extralarge || img.large, large: img.large, small: img.small, cover: false, placeholder: img.placeholder, alt: img.alt, title: img.title}
                }
            } 
            if(this.editing){
                this.editField()   
            } else {
                this.addField()
            }      
            
        }
    }
}
</script>


// WEBPACK FOOTER //
// PageEdit.vue?83a8ab44